import jQuery from 'jquery';

const hash = window.location.hash;

jQuery(function($) {
  const $hwwModal = $('#how-we-work-modal');
  const $hwwVideo = $('.how-we-work__video').get(0);

  if (hash === '#how-we-work') {
    $('html, body').animate({
      scrollTop: $('.how-we-work').offset().top - 150,
    }, 700, 'swing', function() {
      $hwwModal.modal('show');
    });
  }

  $hwwModal.on('show.bs.modal', function(e) {
    $hwwVideo.play();
  });

  $hwwModal.on('hide.bs.modal', function(e) {
    $hwwVideo.pause();
  });
});
